import useMutationApi from 'src/api/useMutationApi';

interface Body {
  name: string;
  description: string;
}

interface ApiResponse {
  group: {
    id: string;
    name: string;
    description: string;
  };
}

export function useEditGroup(groupId: string) {
  return useMutationApi<Body, ApiResponse>({
    endpoint: `organization/groups/${groupId}`,
    method: 'PUT',
    successMessage: 'Team updated successfully',
  });
}
